import * as React from 'react';
import { SVGProps } from 'react';

const IconDrillingRigSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 1h6v2h-.977l1.285 6H15v2H1V9h3.692l1.285-6H5V1Zm1.737 8h2.526L8.192 4h-.384L6.737 9Z"
    />
    <path d="M4 6H2v2h2V6ZM12 6h2v2h-2V6ZM2 12h2l-2 3H1v-1.5L2 12ZM8 12H6l-2 3h2l2-3ZM10 15H8l2-3h2l-2 3ZM15 12h-1l-2 3h2l1-1.5V12Z" />
  </svg>
);
export default IconDrillingRigSizeS;
